import {OnInit} from '@angular/core';

export abstract class NavBaseComponent implements OnInit{

  preventDef(event) {
    if (event) {
      event.preventDefault();
    }
  }

  ngOnInit(): void {
  }

}
